import axios from 'axios';
import moment from 'moment';
import * as Sentry from '@sentry/react';

export default async ({ packetId, projectNumber, phaseNumber, packetNid, packetCreated }) => {
	return axios
		.get(
			`/jsonapi/node/project_phase?filter[field_pp_project_number]=${projectNumber}&filter[field_pp_phase]=${phaseNumber}`
		)
		.then(async ({ data: project }) => {
			const date = moment.unix(packetCreated).format('MM-DD-YY');
			const projectId = project.data[0]?.id;
			const createdBy = localStorage.getItem('username');
			const title = `${projectNumber}-${phaseNumber}_${date}_${createdBy}_${packetNid}`;

			return await axios
				.patch(
					`/jsonapi/node/packet/${packetId}`,
					{
						data: {
							type: 'node--packet',
							id: packetId,
							attributes: {
								field_packet_unassigned: {
									value: 'false'
								},
								title: {
									value: title
								}
							},
							relationships: {
								field_packet_project_phase: {
									data: {
										type: 'node--project_phase',
										id: projectId
									}
								}
							}
						}
					},
					{
						headers: {
							Accept: 'application/vnd.api+json',
							'Content-Type': 'application/vnd.api+json'
						}
					}
				)
				.then(() => title);
		})
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
};
